import { Timeline } from "antd";
import { useAppSelector } from "../../../../../../app/store";
import { TicketWorkflow } from "../../../../../../features/superAdmin/ticketService/ticket/ticket.type";
import {
  convertMinutesToHoursShort,
  convertTimeToMinutes,
  formatDate,
  formatTime,
} from "../../../../../../lib/time";
import { TEMPLATE_TYPES } from "../../../constants/ticket.constants";
import SLAActivityItem from "./SLAActivityItem";
import { TabProps } from "./TicketDetailsTabs";
import WorkflowActivityItem from "./WorkflowActivityItem";

const ActivityTab = ({ ticketDetails }: TabProps) => {
  const user_id = useAppSelector((state) => state?.auth?.user?.id);
  const { raiser, created_at, totalSLA, workflows, type } = ticketDetails || {};

  return (
    <div className="h-[calc(100vh_-_385px)] w-full overflow-auto">
      <div>
        <Timeline className="mt-4 text-base">
          {/* Render the ticket create info */}
          <Timeline.Item color="#1DB469">
            <div className="font-semibold text-base text-[#3D4A5C]">
              Ticket Created by {raiser?.officialInfo?.name}
            </div>
            <div className="text-gray-500">
              {formatTime(created_at, "h:mm:ss")} -&nbsp;
              {formatDate(created_at)}&nbsp;-&nbsp; Base SLA:{" "}
              {convertMinutesToHoursShort(convertTimeToMinutes(totalSLA))}
            </div>
          </Timeline.Item>

          {workflows?.map((item: TicketWorkflow, index: number) => {
            const isOpen = ticketDetails?.type === TEMPLATE_TYPES.sla;
            const isFixed = ticketDetails?.type === TEMPLATE_TYPES.workflow;

            const firstAfterDone = item?.employee_id === user_id;
            const isDone = isOpen
              ? item?.is_resolved ||
                item?.is_forwarded ||
                item?.status !== "pending"
              : isFixed
              ? item?.status === "done"
              : false;
            const color = isDone
              ? "#1DB469"
              : firstAfterDone
              ? "#FFD027"
              : "#AFBACA";

            return type === TEMPLATE_TYPES.sla ? (
              <Timeline.Item color={color} key={index}>
                <SLAActivityItem workFlow={item} key={index} />
              </Timeline.Item>
            ) : (
              <Timeline.Item color={color} key={index}>
                <WorkflowActivityItem
                  ticketDetails={ticketDetails}
                  workFlow={item}
                  key={index}
                />
              </Timeline.Item>
            );
          })}
        </Timeline>
      </div>
    </div>
  );
};

export default ActivityTab;
